import React from "react";
import FlightDeckClient from "../flight-deck-client";
export const FlightDeckContext = /*#__PURE__*/React.createContext({
  getArtifact: null
});
export function FlightDeckProvider({
  children,
  product,
  config,
  fallbackArtifacts
}) {
  const flightDeckClient = React.useMemo(() => {
    return new FlightDeckClient(product, {
      handlers: {
        captureException: config === null || config === void 0 ? void 0 : config.captureException
      },
      expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
    }, fallbackArtifacts);
  }, [product, config === null || config === void 0 ? void 0 : config.captureException, fallbackArtifacts]);
  const getArtifact = React.useCallback(async (name, dimensions) => {
    return flightDeckClient.fetchConfigFromFlightDeck({
      name,
      dimensions
    });
  }, [flightDeckClient]);
  const providerValue = React.useMemo(() => ({
    getArtifact
  }), [getArtifact]);
  return /*#__PURE__*/React.createElement(FlightDeckContext.Provider, {
    value: providerValue
  }, children);
}
export const useFlightDeckContext = () => React.useContext(FlightDeckContext);
export function useFlightDeckArtifact(key, dimensions) {
  const [artifact, setArtifact] = React.useState();
  const {
    getArtifact
  } = useFlightDeckContext();
  React.useEffect(() => {
    if (!getArtifact) {
      throw new Error("Flight Deck Context not provided");
    }
    getArtifact(key, dimensions).then(resp => setArtifact(resp))
    // we don't need to do anything with the error as it is already instrumented in the flightDeckClient
    .catch();
  }, [dimensions, key, getArtifact, setArtifact]);
  return artifact;
}